import { useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Performance from "@/pages/Performance";
import Recovery from "@/pages/Recovery";
import Corporate from "@/pages/Corporate";
import About from "@/pages/About";
import Pricing from "@/pages/Pricing";
import Start from "@/pages/Start";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 120);
      return () => clearTimeout(t);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function NotFound() {
  return (
    <main className="flex min-h-[100svh] flex-col items-center justify-center bg-ink px-6 text-center text-bone">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-lime">404</p>
      <h1 className="mt-6 font-display text-5xl font-black uppercase tracking-tight sm:text-7xl">
        Off the program.
      </h1>
      <Link
        to="/"
        data-testid="notfound-home-link"
        className="mt-10 bg-lime px-7 py-4 font-mono text-[11px] uppercase tracking-[0.2em] text-ink transition-colors hover:bg-limed"
      >
        Back to Home
      </Link>
    </main>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programs" element={<Programs />} />
          <Route path="/performance" element={<Performance />} />
          <Route path="/recovery" element={<Recovery />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/start" element={<Start />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
        <FloatingWhatsApp />
      </BrowserRouter>
    </div>
  );
}

export default App;
